import { createContext } from "react";

const MoshiContext = createContext({ moshi_id: 4 });

export default MoshiContext
